import React, { FC, useMemo } from 'react';
import { TooltipRow } from './TooltipRow';
import { InfoDenseIcon, InfoIcon, Tooltip } from '@rubin-dev/goblin';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { BalanceToken } from '@apolloGenerated';
import { format, formatPowAmount } from '@aml/amount';

export type AddressBalanceTooltipProps = {
  totalIn: string;
  totalOut: string;
  active?: boolean;
  offsetValue?: number;
  dense?: boolean;
  network?: string;
  tokens?: BalanceToken[] | null;
};
export const BalanceTooltip: FC<AddressBalanceTooltipProps> = ({
  totalIn,
  totalOut,
  active,
  offsetValue,
  dense,
  network,
  tokens,
}) => {
  const { t } = useTranslation();

  const tokensFilter = useMemo(
    () =>
      tokens?.length &&
      Object.fromEntries(
        tokens
          .filter((item) => ['USDT', 'trx', 'ETH'].includes(item.symbol))
          .map((item) => [item.symbol, [item.balance, item.decimals]]),
      ),
    [tokens],
  );

  const renderForBTC = () => (
    <div className={styles.addressTooltip__wrapper}>
      <TooltipRow label={t('strings.received')} value={totalIn} />
      <TooltipRow label={t('strings.sent')} value={totalOut} />
    </div>
  );

  const renderForTRON = () => {
    if (!tokensFilter) return <></>;
    return (
      <div className={styles.addressTooltip__wrapper}>
        {tokensFilter.USDT && (
          <TooltipRow
            label={'USDT'}
            value={format(
              parseFloat(
                String(formatPowAmount(tokensFilter.USDT[0], tokensFilter.USDT[1])),
              ).toFixed(2),
              2,
            )}
          />
        )}
        {tokensFilter.trx && (
          <TooltipRow
            label={'TRX'}
            value={format(
              parseFloat(
                String(formatPowAmount(tokensFilter.trx[0], tokensFilter.trx[1])),
              ).toFixed(2),
              2,
            )}
          />
        )}
        {/*<Typography variant="body-14" color="on-surface-primary-2">*/}
        {/*  {t('titles.transactionsExcluded')}*/}
        {/*</Typography>*/}
      </div>
    );
  };

  const renderForETH = () => {
    if (!tokensFilter) return <></>;

    return (
      <div className={styles.addressTooltip__wrapper}>
        {tokensFilter.USDT && (
          <TooltipRow
            label={'USDT'}
            value={format(
              parseFloat(
                String(formatPowAmount(tokensFilter.USDT[0], tokensFilter.USDT[1])),
              ).toFixed(2),
              2,
            )}
          />
        )}
        {tokensFilter.ETH && (
          <TooltipRow
            label={'ETH'}
            value={format(
              parseFloat(
                String(formatPowAmount(tokensFilter.ETH[0], tokensFilter.ETH[1])),
              ).toFixed(2),
              2,
            )}
          />
        )}
      </div>
    );
  };

  const renderLabel = () => {
    switch (network) {
      case 'BTC':
        return renderForBTC();
      case 'TRON':
        return renderForTRON();
      case 'ETH':
        return renderForETH();
    }
  };

  return (
    <Tooltip
      active={active}
      placement={'bottom-start'}
      width={400}
      offsetValue={offsetValue}
      label={renderLabel() || ''}
    >
      <div className={styles.addressTooltip__iconWrap}>
        {dense ? (
          <InfoDenseIcon className={styles.addressTooltip__icon} />
        ) : (
          <InfoIcon className={styles.addressTooltip__icon} />
        )}
      </div>
    </Tooltip>
  );
};
